import React from 'react';
import cx from 'classnames';

import { StarIcon } from '@motorway/mw-highway-code';

import styles from './ShortlistStar.module.scss';

const SPACEBAR_KEYCODE = 32;

type ShortlistStarProps = {
	checked?: boolean;
	className?: string;
	inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
	onChange: (e: React.SyntheticEvent) => void;
	rounded?: boolean;
};

export const ShortlistStar: React.FC<ShortlistStarProps> = ({
	checked = false,
	className,
	inputProps = {},
	onChange,
	rounded = false,
}) => {
	const handleChecked = (e: React.FormEvent) => {
		onChange(e);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e?.keyCode === SPACEBAR_KEYCODE) {
			// spacebar will scroll the page. We don't want this to happen if the focus is on ShortlistStar component
			e.preventDefault();

			handleChecked(e);
		}

		return null;
	};

	const handleOnClick = (e: React.MouseEvent) => {
		e.preventDefault();

		handleChecked(e);
	};

	return (
		<label
			aria-checked={checked}
			aria-label="Add to shortlist"
			className={cx(styles.shortlistStar, { [styles.rounded]: rounded }, className)}
			htmlFor={inputProps?.id}
			onClick={handleOnClick}
			onKeyDown={handleKeyDown}
			tabIndex={0}
		>
			<StarIcon filled={checked} size={rounded ? 'small' : 'medium'} />
			<input className={styles.input} defaultChecked={checked} name="favourite" type="checkbox" {...inputProps} />
		</label>
	);
};
